// src/stores/loading.js
import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useLoadingStore = defineStore("loading", () => {
  const counter = ref(0);
  const minDisplayMs = 200; // 플리커 방지용 최소 표시시간 (ms)

  let showTimeout = null;
  let firstShownAt = 0;

  const isLoading = computed(() => counter.value > 0);

  function _show() {
    // 최소 표시시간을 위해 타이밍 관리
    if (counter.value === 0) {
      firstShownAt = Date.now();
    }
    counter.value++;
  }

  function _hide() {
    if (counter.value <= 0) return;
    counter.value--;
    if (counter.value === 0) {
      const elapsed = Date.now() - firstShownAt;
      const remaining = minDisplayMs - elapsed;
      if (remaining > 0) {
        // 남은 시간 동안 유지
        if (showTimeout) clearTimeout(showTimeout);
        showTimeout = setTimeout(() => {
          showTimeout = null;
        }, remaining);
      }
    }
  }

  function reset() {
    counter.value = 0;
    if (showTimeout) {
      clearTimeout(showTimeout);
      showTimeout = null;
    }
  }

  return {
    counter,
    isLoading,
    show: _show,
    hide: _hide,
    reset,
  };
});
